import * as type from '../actions/types';

const initialState = {
  pending: false,
  error: '',
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.CONTACT_BDM_PENDING:
      return {
        ...state,
        pending: true,
        error: '',
      };
    case type.CONTACT_BDM_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
      };
    case type.CONTACT_BDM_FAILURE:
      return {
        ...state,
        error: action.payload,
        pending: false,
      };

    case type.CLEAR_CONTACT_BDM:
      return {
        ...state,
        pending: false,
        error: '',
        success: false,
      };

    default:
      return state;
  }
};
